import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import recordIcon from '../../fsa-style/img/svgs/record_grey.svg';
import recordIconWhite from '../../fsa-style/img/svgs/record_white.svg';
import scanIcon from '../../fsa-style/img/svgs/scan_grey.svg';
import scanIconWhite from '../../fsa-style/img/svgs/scan_white.svg';
import magnifyingGlassWhite from '../../fsa-style/img/svgs/magnifying-glass.svg';
import magnifyingGlassGrey from '../../fsa-style/img/svgs/magnifying-glass-grey.svg';
import buowIcon from '../../fsa-style/img/svgs/buow_white.svg';
import Administrator from '../../fsa-style/img/svgs/admin_blue.svg';
import houseGrey from '../../fsa-style/img/svgs/house.svg';
import houseWhite from '../../fsa-style/img/svgs/house-white.svg';

import AdministratorIconWhite from '../../fsa-style/img/svgs/admin_white.svg';
import dashboardIcon from '../../fsa-style/img/svgs/dashboard_grey.svg';
import dashboardIconWhite from '../../fsa-style/img/svgs/dashboard_white.svg';
import './SideNavBar.scss';
import UserContext from '../UserContext/UserContext';
import { fixedPermissions } from '../../utils/helper/permissionFinder';
import FetchLocalStorageDataByPath from '../../utils/helper/FetchLocalstorageDataByPath';
import { EventEmitter } from '../../services/events';
import { buowLockLooper } from '../../services/inBasketService';
const SideNavBar = ({ logout }) => {
  const [selectedLink, isLinkSelected] = useState('/');
  const [showPopup, setPopupVal] = useState(false);
  const userRole = JSON.parse(sessionStorage.getItem('permissions'));
  const [isFeatureActive, setisFeatureActive] = useState({});
  const navigateTo = useNavigate();

  const adminPanelRoutes = [
    'admin',
    'orchestration',
    'routingsteps',
    'systemconfiguration',
    'ruledefinition',
    'userstable',
    'rolestable',
    'permissionstable',
    'user-preference',
    'system-folder',
    'buowtable',
    'userguide',
    'work-group',
    'messages',
    'inbaskettable',
    'buowdisplayname',
    'work-group',
    'unit-of-work',
    'workgroupuserxwalk',
    'rule-log',
    'ruletrigger',
    'object-hierarchy-table',
    'elements',
    'element-group',
    'redactionhistorytable',
    'redaction-reference',
    'objectdefinition',
    'redaction-actor',
    'objectdictionaryobject',
    'redaction-reason',
    'objectdictionaryobjecttype',
    'redactiondefinition',
    'routingconditions',
    'batchdefinition',
    'packager-preferred-order',
    'packager-configuration',
    'batch-xwalk',
    'objectdefinitiontable',
    'dashboard-indicator',
    'dashboard-indicators-dataSet-card-xref',
    'sec-role-dashboard-card-xref',
    'dashboard-group-card-xref',
    'dashboard-indicators-group',
    'dashboard-card-benchmark-display',
    'indicators-data-set',
    'elementgroupxwalk',
    'emailtemplate',
    'ruletriggermetadata',
    'redaction-configuration',
    'roleworkgroupxwalk',
    'filecodes-admin',
    'schedules-admin',
  ];

  const visibilityRoutes = ['dashboard', 'search', 'inbasket', 'adminpanel', 'recordmanagement', 'fileintake'];

  const getLocalStorageDataFunc = async () => {
    try {
      const fetchedLocalStorageData = FetchLocalStorageDataByPath('system_config', 'features') ?? [];
      (await fetchedLocalStorageData.length) > 0 &&
        fetchedLocalStorageData.map((values) => {
          let newKey = values.title.toLowerCase().replace(/\s/g, '');
          if (
            visibilityRoutes.map((item) => {
              return item === newKey;
            })
          ) {
            setisFeatureActive((prev) => ({
              ...prev,
              [newKey]: values.value,
            }));
          }
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getLocalStorageDataFunc();

    EventEmitter.on('LocalStorageUpdated', getLocalStorageDataFunc);

    return () => {
      EventEmitter.off('LocalStorageUpdated', getLocalStorageDataFunc);
    };
  }, []);

  const recordMgmtRoutes = ['schedule', 'filecode', 'holds', 'transfer', 'manage'];

  const [userPermissions, setUserPermissions] = useState({});
  const onSelectLink = (val) => {
    setPopupVal(false);
    isLinkSelected(val);
  };
  const navigateSelectLink = (val) => {
    navigateTo(`/${val}`);
  };

  const location = useLocation();

  useEffect(() => {
    if (window.location.pathname.split('/')[window.location.pathname.split('/').length - 1] !== window.sessionStorage.getItem('BUOW_id')) {
      if (window.sessionStorage.getItem('lock_id') !== 'null' && window.sessionStorage.getItem('lock_id') !== null) {
        buowLockLooper(window.sessionStorage.getItem('lock_id'), false);
        window.sessionStorage.setItem('lock_id', null);
        window.sessionStorage.setItem('BUOW_id', null);
      }
    }
  });
  useEffect(() => {
    async function data() {
      findPermissions();
    }
    data();
    isLinkSelected(window.location.pathname.length > 1 ? window.location.pathname.split('/')[1] : window.location.pathname);
  }, [location]);

  const handleLeave = () => setPopupVal(false);

  const handleHover = () => setPopupVal(true);
  const findPermissions = () => {
    try {
      const storedPermissions = JSON.parse(sessionStorage.getItem('permissions') || '[]');

      const fixedPermissionSet = new Set(fixedPermissions);

      const userPermissions = storedPermissions.reduce((acc, perm) => {
        if (fixedPermissionSet.has(perm)) {
          acc[perm] = true;
        }
        return acc;
      }, {});

      setUserPermissions(userPermissions);
    } catch (error) {
      console.error('Error processing permissions', error);
    }
  };
  return (
    <>
      {/* navbar Start */}
      <nav className="navBarcontainer">
        <div className="nav_active">
          {userPermissions['My_In_Basket'] === true && isFeatureActive?.inbasket === true && selectedLink !== 'buow' && (
            <div
              className={selectedLink === 'inbasketpage' || selectedLink === '/' ? 'abcLink1 thinLine' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('inbasketpage');
                navigateSelectLink('inbasketpage');
              }}
            >
              {selectedLink === 'inbasketpage' || selectedLink === '/' ? (
                <img src={houseWhite} alt="Go to in-basket page" className="scan_base_icon Categories" style={{ width: '19.13px', height: '17.5px' }} />
              ) : (
                <img src={houseGrey} alt="Go back to in-basket page" className="scan_base_icon Categories" style={{ width: '19.13px', height: '17.5px' }} />
              )}
            </div>
          )}

          {selectedLink === 'buow' && (
            <div
              className={selectedLink === 'buow' ? 'abcLink1 thinLine' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink(selectedLink === 'buow' ? 'inbasketpage' : 'buow');
                navigateSelectLink(selectedLink === 'buow' ? 'inbasketpage' : 'buow');
              }}
            >
              <img
                src={selectedLink === 'buow' ? buowIcon : houseGrey}
                alt={selectedLink === 'buow' ? 'Access Buow Page' : 'Go back to in-basket page'}
                className="scan_base_icon"
                style={selectedLink !== 'buow' ? { width: '19.13px', height: '17.5px' } : {}}
              />
            </div>
          )}

          {isFeatureActive?.fileintake === true && userPermissions['Scan_On_Demand_Page'] && (
            <div
              className={selectedLink === 'scan' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('scan');
                navigateSelectLink('scan');
              }}
            >
              {selectedLink === 'scan' ? (
                <img src={scanIconWhite} alt="File-intake page" className="scan_base_icon" />
              ) : (
                <img src={scanIcon} alt="Go to File-intake page" className="scan_base_icon" />
              )}
            </div>
          )}

          {isFeatureActive?.search === true && userPermissions['Search_Page'] === true && (
            <div
              className={selectedLink === 'search' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('search');
                navigateSelectLink('search');
              }}
            >
              {selectedLink === 'search' ? (
                <img src={magnifyingGlassWhite} alt="Search page" className="scan_base_icon Categories" style={{ width: '17.01px', height: '17.5px' }} />
              ) : (
                <img src={magnifyingGlassGrey} alt="Go to Search page" className="scan_base_icon Categories" style={{ width: '17.01px', height: '17.5px' }} />
              )}
            </div>
          )}

          {isFeatureActive?.recordmanagement === true && userPermissions['Record_Management'] === true && (
            <Link
              to={'schedule'}
              className={recordMgmtRoutes.includes(selectedLink) === true ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => onSelectLink('schedule')}
              onMouseLeave={handleLeave}
              onMouseOver={handleHover}
            >
              {recordMgmtRoutes.includes(selectedLink) === true ? (
                <div>
                  <img src={recordIconWhite} alt="Recod Management" className="base_icon" />
                  {showPopup && <DropdownList selectedLink={selectedLink} onSelectLink={onSelectLink} userPermissions={userPermissions} onHover={handleHover} onLeave={handleLeave} />}
                </div>
              ) : (
                <div>
                  <img src={recordIcon} alt="Go to Record Management Page" className="base_icon" />
                  {showPopup && <DropdownList selectedLink={selectedLink} onSelectLink={onSelectLink} userPermissions={userPermissions} onHover={handleHover} onLeave={handleLeave} />}
                </div>
              )}
            </Link>
          )}

          {isFeatureActive?.dashboard === true && userPermissions['View_Dashboard'] === true && (
            <div
              className={selectedLink === 'dashboard' ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('dashboard');
                navigateSelectLink('dashboard');
              }}
            >
              {selectedLink === 'dashboard' ? (
                <img src={dashboardIconWhite} alt="Dashboard" className="base_icon" />
              ) : (
                <img src={dashboardIcon} alt="Go to Dashboard" className="base_icon" />
              )}
            </div>
          )}

          {((userPermissions['Administrator_Panel'] === true &&
            userRole &&
            userRole.length > 0 &&
            (userRole.includes('Admin') || userRole.includes('Application Administrator') || userRole.includes('Redaction Admin'))) ||
            (userPermissions['Administrator_Panel'] === true &&
              isFeatureActive?.adminpanel === true &&
              userRole &&
              userRole.length > 0 &&
              (userRole.includes('Admin') || userRole.includes('Application Administrator') || userRole.includes('Redaction Admin'))) ||
            userPermissions['Administrator_Panel'] === true) && (
            <div
              className={adminPanelRoutes.includes(selectedLink) ? 'abcLink1' : 'navLink style_NavPill'}
              onClick={() => {
                onSelectLink('admin');
                navigateSelectLink('admin');
              }}
            >
              <img src={adminPanelRoutes.includes(selectedLink) ? AdministratorIconWhite : Administrator} alt="Navigate to Admin Panel" className="base_icon" />
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

const DropdownList = (props) => {
  const groups = sessionStorage.getItem('groups') !== 'undefined' ? JSON.parse(sessionStorage.getItem('groups')) : [];
  const isAdmin = Array.isArray(groups) && groups.includes('Admin');

  return (
    <div
      className="dropdownList"
      onMouseEnter={props.onHover}
      onMouseLeave={props.onLeave}
    >
      {isAdmin && props.userPermissions['Record_Schedule'] === true && (
        <Link to="/schedule" onClick={() => props.onSelectLink('schedule')}>
          <li className={props.selectedLink === 'schedule' ? 'selectedLink' : ''}>Create Schedule</li>
        </Link>
      )}

      {isAdmin && props.userPermissions['File_Management'] === true && (
        <Link to="/filecode">
          <li className={props.selectedLink === 'filecode' ? 'selectedLink' : ''}>Manage File Code</li>
        </Link>
      )}

      {props.userPermissions['Hold_Management'] === true && (
        <Link to="/holds">
          <li className={props.selectedLink === 'holds' ? 'selectedLink' : ''}>Manage Holds</li>
        </Link>
      )}

      {props.userPermissions['Transfer_Management'] === true && (
        <Link to="/transfer">
          <li className={props.selectedLink === 'transfer' ? 'selectedLink' : ''}>Manage Transfers</li>
        </Link>
      )}

      {props.userPermissions['Disposition_Management'] === true && (
        <Link to="/manage">
          <li className={props.selectedLink === 'manage' ? 'selectedLink' : ''}>Manage Disposition</li>
        </Link>
      )}
    </div>
  );
};

export default SideNavBar;
